// src/components/perfil/components/EditProfileForm.js

import React from 'react';

function EditProfileForm({ newUser, loadForm, updateUser }) {
  return (
    <div className="tab-pane fade show active" id="primeira-aba" role="tabpanel">
      {/* Nome e Nome Fantasia */}
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label className="required">Nome</label>
            <input
              type="text"
              name="nome"
              className="form-control"
              id="nome"
              value={newUser.nome}
              onChange={loadForm}
              required
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Nome Fantasia</label>
            <input
              type="text"
              name="nome_fantasia"
              className="form-control"
              id="nome_fantasia"
              value={newUser.nome_fantasia}
              onChange={loadForm}
            />
          </div>
        </div>
      </div>

      {/* Telefones */}
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label className="required">Telefone 1</label>
            <input
              type="text"
              className="form-control"
              maxLength={15}
              name="telefone1"
              id="telefone1"
              value={newUser.telefone1}
              onChange={loadForm}
              required
            />
          </div>
        </div>
        <div className="col-6">
          <div className="form-group">
            <label>Telefone 2</label>
            <input
              type="text"
              className="form-control"
              maxLength={15}
              name="telefone2"
              id="telefone2"
              value={newUser.telefone2}
              onChange={loadForm}
            />
          </div>
        </div>
      </div>

      {/* Email */}
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <label className="required">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              id="email"
              placeholder="meuemail@email.com"
              value={newUser.email}
              onChange={loadForm}
              required
            />
          </div>
        </div>
      </div>

      {/* Endereço, Número e Complemento */}
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label>Endereço</label>
            <input
              type="text"
              className="form-control"
              name="endereço"
              id="endereço"
              value={newUser.endereço}
              onChange={loadForm}
            />
          </div>
        </div>
        <div className="col-2">
          <div className="form-group">
            <label>N°</label>
            <input
              type="text"
              className="form-control"
              name="numero"
              id="numero"
              value={newUser.numero}
              onChange={loadForm}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-group">
            <label>Complemento</label>
            <input
              type="text"
              className="form-control"
              name="complemento"
              id="complemento"
              value={newUser.complemento}
              onChange={loadForm}
            />
          </div>
        </div>
      </div>

      {/* UF, Cidade e CEP */}
      <div className="row">
        <div className="col-6">
          <div className="form-group">
            <label>U.F.</label>
            <input
              type="text"
              className="form-control"
              name="uf"
              id="uf"
              value={newUser.uf}
              onChange={loadForm}
            />
          </div>
        </div>
        <div className="col-2">
          <div className="form-group">
            <label>Cidade</label>
            <input
              type="text"
              className="form-control"
              name="cidade"
              id="cidade"
              value={newUser.cidade}
              onChange={loadForm}
            />
          </div>
        </div>
        <div className="col-4">
          <div className="form-group">
            <label>CEP</label>
            <input
              type="text"
              className="form-control"
              name="cep"
              id="cep"
              value={newUser.cep}
              onChange={loadForm}
            />
          </div>
        </div>
      </div>

      {/* Botão de Atualização */}
      <div className="row">
        <div className="col-md-12 text-center">
          <button className="btn btn-success" id="atualizar" onClick={updateUser}>
            Atualizar Perfil
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditProfileForm;
